/* Money in the panel: cents in, "$42" out, with cents only when an amount really has them (a prorated Stripe line). Prices come from the API or @hosterr/pricing, never from here. */

const whole = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
const cents = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** "$42" for whole dollars (every list price is); cents only when there are some, like "$3.50"; a credit reads "−$3.50". */
export function money(amount: number): string {
  const abs = Math.abs(amount);
  const s = abs % 100 === 0 ? whole.format(abs / 100) : cents.format(abs / 100);
  return amount < 0 ? `−${s}` : s;
}

export const years = (n: number) => (n === 1 ? "1 year" : `${n} years`);

/** "4 sites at $42 = $168" */
export function lineWords(quantity: number, one: string, many: string, unitAmount: number, amount: number): string {
  return `${quantity} ${quantity === 1 ? one : many} at ${money(unitAmount)} = ${money(amount)}`;
}
